const { utils } = require("sortablejs");

import { goToUrl } from 'js/vue/helpers';

(((XHR) => {

    const open = XHR.prototype.open;
    const send = XHR.prototype.send;

    XHR.prototype.open = function() {
        this.addEventListener('load', () => {
            if (this.readyState === 4) handlerResponse(this);
        });
        this.addEventListener('abort', () => {
            Push.isDisabledToast = true;
            setTimeout(() => Push.isDisabledToast = false);
            return;
        })
        this.addEventListener('error', () => {
            if (this.status === 0 && this.readyState === 4) {
                handlerNetworkFailure();
                return;
            }
        })
        return open.apply(this, arguments);
    };

    XHR.prototype.send = function() {
        return send.apply(this, arguments);
    };

}))(XMLHttpRequest);

/**
 * According on the status of the response
 * We call the corresponding handler method
 * 1xx: Information
 * 2xx: Successful
 * 3xx: Redirection
 * 4xx: Client Error
 * 5xx: Server Error
 *
 * @param {Object} response
 */
const handlerResponse = (response) => {
    switch (+response.status.toString().charAt(0)) {
        case 4:
            handlerClientError(response);
            break;
    }
};

/*
    If readyState of response is 4, it's mean response are done but if status is 0 an error has occurred
    https://stackoverflow.com/questions/21241553/how-do-i-tell-if-an-xmlhttprequest-failed-due-to-a-network-issue
 */
const handlerNetworkFailure = () => {
    Push.settings.preventDuplicates = true;
    Push.isDisabledToast = true;
    setTimeout(() => Push.isDisabledToast = false);
}

/**
 * 4xx: Client Error
 * According with status
 * We call the method for handling the corresponding client error
 *
 * @param {Object} response
 */
const handlerClientError = (response) => {
    let saasPreloader = document.getElementById('saas-preloader')
    if(null !==  saasPreloader && saasPreloader.style.display === 'block') MyFacture.stopWait();

    switch (response.status) {
        case 400:
            handleBadRequest(response)
            break;
        case 402:
            handlePaymentRequired(response)
            break;
        case 403:
            handleForbidden(response)
            break;
        case 404:
            // too hard in redirect when 404
            // handleNotFound();
            break;
        }
}

const handleBadRequest = (response) => {
    let responseError;
    try {
        responseError = JSON.parse(response.getResponseHeader('X-Json-Error'));
    } catch (e) {
        responseError = null;
    }

    const status = responseError?.error?.details?.status || null;

    if (status === 'validated') {
        goToUrl(window.sellsyapp.config.globalProperties.$router.resolve({ name: 'error.cart.expired' }).href);
        return
    }
}

/**
 * Handle the 402 error (payment required)
 *  - disable push toast for not show "system error"
 *  - close old-fashioned form popups only if popup with error message
 *  - show popup quota limit reached
 * @param {*} response
 */
const handlePaymentRequired = (response) => {

    let responseError;
    try {
        responseError = JSON.parse(response.getResponseHeader('X-Json-Error'));
    } catch (e) {
        responseError = null;
    }

    const module        = responseError?.error?.details?.module || '';
    const limit         = responseError?.error?.details?.limit  || 0;

    console.error(`${response.status} ${response.statusText}`, responseError);


    // Deactivate toast system
    Push.isDisabledToast = true;

    // Show popup Quota
    if (module || limit) {
        window.Quota.showLimitReached(module, limit);
    }

    if (responseError?.error?.context === "payment_required_plan") {
        window.sellsyapp.config.globalProperties.$store.state.popupPanel.featureModal.props = {};
        window.sellsyapp.config.globalProperties.$store.state.popupPanel.featureModal.display = true;
    }

    const hasLegacyPopupFormOpen = !!MyWindow.getRoot().length;

    if (hasLegacyPopupFormOpen) {
        // Close the pop-up form if the message displayed follows the 402 error
        setTimeout(() => {
            const isErrorInjectedIntoPopup = !!(
                MyWindow.getOption()[0].getElementsByClassName('sellsyErrorContainer').length || // case where back return template for error
                MyWindow.getOption()[0].innerHTML === '[object Object]' // case where back return json for error
            );
            if (isErrorInjectedIntoPopup) MyWindow.close();
        });
    } else {
        // Otherwise stop rest of script
        response.abort();
    }

    // Reactivate toast system
    setTimeout(() => Push.isDisabledToast = false);

}

/**
 * Handle the 403 error (forbidden)
 * @param {*} response
 */
 const handleForbidden = (response) => {
    let responseError
    try {
        responseError = JSON.parse(response.getResponseHeader('X-Json-Error'))
    } catch (e) {
        responseError = null
    }

    const context = responseError?.error?.context || null

    if (context === 'sam_cart_expired' || context === 'sam_cart_forbidden_access') {
        goToUrl(window.sellsyapp.config.globalProperties.$router.resolve({name: 'error.cart.expired'}).href)
        return
    }

    if (['blocked','basic','trialend','no_license'].includes(context)) {
        document.location.reload();
    }
}

const handleNotFound = () => {
    goToUrl(window.sellsyapp.config.globalProperties.$router.resolve({ name: 'error.not.found' }).href);
}
